/**
 * generates an Authorization header for the currently logged in blockv user
 *
 * @param authType the appropriate auth type of the request
 */
import * as Blockv from "../MainBv.js"

export default function generateAuthHeader(authType: string) {
	if (authType === "refresh_token") {
		// todo: use public api for this
		return "Bearer " + Blockv.instance.store.refreshToken;
	} else if (authType === "access_token") {
		return "Bearer" + Blockv.instance.UserManager.getAccessToken();
	} else {
		throw new Error(`generateAuthHeader: unrecognized auth type "${authType}"`);
	}
}



// WEBPACK FOOTER //
// ./src/utils/auth_header.ts